export default __webpack_public_path__ + "static/media/smallIntermission5.3c2f8175.mp3";